/**
 * Facebook Page Plugin + Google Maps
 *
 * @summary Mappa personalizzata con https://snazzymaps.com/
 * @global jQuery
 * @requires plugins/jquery.googlemaps.js
 * @author Daniele De Nobili
 */

(function () {
	"use strict";

    window.onFirstUserInteraction(function(){
        var d = document,
            t = 'script';

        function l(u) {
            var j = d.createElement(t),
                s = d.getElementsByTagName(t)[0];

            j.src = u;
            j.async = 1;
            s.parentNode.insertBefore(j, s);
        }

        /* Facebook Page Plugin */
        if (typeof fb_lang !== 'undefined') {
            window.fbAsyncInit = function () {
                FB.init({
                    appId	: fb_appId,
                    status	: true,
                    xfbml	: true,
                    version	: 'v3.2'
                });
            };
            l('//connect.facebook.net/' + fb_lang + '/sdk.js');
        }

        /* Google Maps */
        var map = $('#js-gmap');

        if (map) {
            l('//maps.googleapis.com/maps/api/js?key=AIzaSyAO4ycwmVie3JhnpJx7-_b_kg629w_g7ZU&v=3.exp&callback=initialize');

            window.initialize = function () {
                map.googlemaps({
                    style: [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}]
                });
            };
        }
    });
}());
